import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  UIManager,
  Platform,
  Animated,
  ActivityIndicator,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import momentActions from "app/utils/momentActions";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import chapterHelpers from "app/utils/chapterHelpers";
import momentHelpers from "app/utils/momentHelpers";
import timeHelpers from "app/utils/timeHelpers";
import richTextHelpers from "app/utils/richTextHelpers";
import haptics from "app/utils/haptics";
import {
  styleSheet,
  colors,
  sizes,
  mobileIncrease,
  largeFactor,
} from "app/utils/styleSheet";
import {
  FontAwesome,
  FontAwesome5,
  Entypo,
  MaterialIcons,
  MaterialCommunityIcons,
  AntDesign,
  Feather,
} from "@expo/vector-icons";

import Hoverable from "app/components/Hoverable";
import Draggable from "app/components/Draggable";

import Tooltip from "app/components/Tooltip";
import Icon from "app/components/Icon";
import MomentRing from "app/components/chapter/MomentRing";

import store from "app/redux/store";

import { StyleContext } from "app/contexts/Style";

let QUOTA_PERCENT = false;
let CHAPTER_QUOTA_PERCENT = false;
let ENABLED_SCROLL_TO_SET_QUOTA = true;
ENABLED_SCROLL_TO_SET_QUOTA = false;

export default class Badge extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    invertNote: PropTypes.bool,
    invertCompleted: PropTypes.bool,
    inspect: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isHovered: false,
      isDragging: false,
      metaKey: false,
      updatingQuota: false,
      allowUpdatingQuota: false,
      quota: props.moment?.quota || 0,
      scrollDiff: 0,
      disableQuotaEdit: typeof props.moment?.id != "number",
      quotaHasChanged: false,
    };
    this.scrollDiff = 0;
  }

  determineStatus = () => {
    let { moment, statusOverride, chapter, placeholder } = this.props;
    if (placeholder) return "placeholder";
    let status = statusOverride || momentHelpers.getStatus(moment, chapter);
    if (!!moment?.value?.id && !moment?.value?.icon) {
      status = "open";
    }
    // status = "manual";
    // console.log("STATUS", status, moment);

    let { invertNote, invertCompleted } = this.props;

    if (invertNote) {
      if (status == "note") return "open";
    } else if (invertCompleted) {
      if (status == "completion") return "open";
    }

    return status;
  };

  render() {
    let SIZE = ENV.WEB ? 100 : 100;
    let sizeFactor = SIZE / 100;
    let { inspect, mobileLarge, checkIcon, pinIcon, small, giant, chapter } =
      this.props;
    let {
      isDragging,
      isHovered,
      showActions,
      updatingQuota,
      allowUpdatingQuota,
      quota,
      disableQuotaEdit,
    } = this.state;

    let {
      moment,
      expanded,
      style,
      noTooltip,
      showActionsOnHover,
      bulletIsHovered,
      loading,
      ignoreHover,
    } = this.props;
    let showTooltip = noTooltip ? false : true;
    let value = moment?.value;

    let iconName = valueHelpers.getIcon(value);

    // default values
    let color = valueHelpers.getColor(
      value,
      this.context.colorScheme,
      this.context.colors.foreground,
    );
    let dimColor = colorHelpers.hexToRgbaString(color, ENV.LIGHT ? 0.6 : 0.9);
    let extraDimColor = colorHelpers.hexToRgbaString(
      color,
      ENV.LIGHT ? 0.5 : 0.3,
    );
    let darkColor = colorHelpers.modifyHex(color, ENV.LIGHT ? 0.8 : 0.5);

    // let extraDimColor = colorHelpers.modifyHex(color, ENV.LIGHT ? 0.8 : 0.3);
    // let iconSize = this.context.sizes.smallItemHeight;
    let iconSize = this.context.sizes.base * 1.2;
    let ringSize = this.context.sizes.large;
    if (small) {
      iconSize *= 0.8;
      ringSize *= 0.75;
    } else if (giant) {
      iconSize *= 1.8;
      ringSize *= 1.75;
    }
    if (mobileLarge) {
      iconSize *= mobileIncrease;
      ringSize *= mobileIncrease;
    }
    let borderWidth = 1;

    iconSize *= sizeFactor;
    ringSize *= sizeFactor;
    borderWidth *= sizeFactor;

    // iconSize *= 1.2;
    if (ENV.WEB && !small) ringSize *= 1.2;
    // iconSize *= 0.8;

    let backgroundColor = this.context.colors.empty;
    let ringColor = color;
    let iconColor = color;
    let strokeFactor = 1;
    let borderRadius = valueHelpers.isTaskOrTracker(value) ? 2 : 999;
    borderRadius = 999;
    let borderColor = extraDimColor;

    let borderStyle = {};
    let popEffect = false;

    let status = this.determineStatus();
    // let notches = this.determineNotches(status);
    let scale = this.props.scale || null;
    let percent = null;
    let quotaWithinRange = null;
    let eventsWithinRange = null;

    // modify for status
    if (["note"].includes(status)) {
      // note
      iconColor = color;
      borderWidth = 0;
      backgroundColor = "transparent";
    } else if (["event"].includes(status)) {
      borderRadius = 2;
      let baseScale = scale || 1;
      scale = baseScale * 0.8;

      iconColor = color;
      backgroundColor = this.context.colors.empty;
      borderWidth = 1;

      if (!!moment?.completed_at || !!moment?.value?.completed_at) {
        iconColor = this.context.colors.empty;
        borderWidth = 0;
        backgroundColor = color;
      }
    } else if (["topic"].includes(status)) {
      // borderRadius = 2;
      let baseScale = scale || 1;
      scale = baseScale * 0.8;

      iconColor = color;
      backgroundColor = this.context.colors.empty;
      borderWidth = 5;
      // borderColor = "red";

      // if (!!moment?.completed_at || !!moment?.value?.completed_at) {
      // iconColor = this.context.colors.empty;
      // borderWidth = 0;
      // backgroundColor = color;
      // }
    } else if (["completion"].includes(status)) {
      // completed value
      backgroundColor = color;
      iconColor = this.context.colors.empty;
      borderColor = backgroundColor;
      // invert
      // backgroundColor = color;
      // iconColor = darkColor;
      // backgroundColor = darkColor;
      // iconColor = colorHelpers.modifyHex(color, 1.3);
      // borderWidth = 0;
      popEffect = true;
      percent = 0;
      ringColor = "transparent";
      // strokeFactor = 2;
    } else if (["progressed_value"].includes(status)) {
      // progressed value (completed moment)
      backgroundColor = color;
      iconColor = this.context.colors.empty;
      borderColor = backgroundColor;
      // invert
      // backgroundColor = color;
      // iconColor = darkColor;
      // backgroundColor = darkColor;
      // iconColor = colorHelpers.modifyHex(color, 1.3);
      // borderWidth = 0;
      popEffect = true;
      percent = 0;
      ringColor = "transparent";
    } else if (["progress", "placeholder"].includes(status)) {
      // check mark
      iconColor = value?.icon_color || this.context.colors.lightForeground;
      backgroundColor = color;
      if (status == "placeholder") {
        iconColor = this.context.colors.empty;
        backgroundColor = this.context.colors.trim;
      }
      // notches = [];
    } else if (status == "composer") {
      // create progress
      // iconColor = color;
      // backgroundColor = this.context.colors.empty;
      // ringColor = color;
      // close composer
      iconColor = this.context.colors.trim;
      backgroundColor = this.context.colors.empty;
      ringColor = this.context.colors.trim;
    } else if (status == "open") {
      // pinned item, open child
      ringColor = dimColor;
      iconColor = dimColor;
      borderColor = extraDimColor;
      if (!!chapter && chapter.range > 1) {
        // && !!value?.frequency) {
        let frequency = value?.frequency || 1;
        // this works wonderfully (except for not counting collapsed sub-chapters), but too big of a performance hit
        if (QUOTA_PERCENT) {
          let range = {
            startAt: timeHelpers.beginningOfDay(
              timeHelpers.dateToDateTime(chapter.start_at),
            ),
            endAt: timeHelpers.endOfDay(
              timeHelpers.dateToDateTime(chapter.end_at),
            ),
          };
          let events = [];
          eventsWithinRange = 0;
          quotaWithinRange = 1;
          // let events = valueHelpers
          //   .getTimeline(value, true, 0, range)
          //   .filter((e) => ["progress", "completion"].includes(e.category));
          // // console.log("EVENTS-----", value?.title, events.length / (value?.frequency * chapter.range), events);
          // quotaWithinRange = Math.floor(chapter.range / frequency);
          // eventsWithinRange = events.length;
          percent = eventsWithinRange / quotaWithinRange;
        } else if (CHAPTER_QUOTA_PERCENT) {
          if (!!moment?.quota) {
            // percent =
          }
          // chapter
        }
      }
    } else if (status == "manual") {
      ringColor = color;
      // iconColor = this.context.colors.empty;
      iconColor = color;
      borderColor = color;
      // backgroundColor = color;
      // iconColor = colorHelpers.modifyHex(color, 0.3);
      // borderColor = "transparent";
    }

    if (!iconName) {
      ringColor = "transparent";
      borderColor = "transparent";
    }

    if (isHovered) {
      // iconColor = color;
      // iconSize = this.context.sizes.smallItemHeight;
    }

    // let percent = null;
    if (this.props.highlighted) {
      // notches = [1];
      percent = 1;
      ringColor = color;
    }

    // let opacity = 0.5;
    let opacity = 1;
    if (
      ["completion", "progress", "progressed_value"].includes(status) ||
      isHovered
    ) {
      opacity = 1;
      percent = 0;
    }

    if (this.props.bulletOnly)
      return (
        <TouchableOpacity
          onPress={(e) => {
            if (!!this.props.onPress) {
              haptics.success();
              this.props.onPress(e);
            }
          }}
          onDoublePress={this.props.onDoublePress}
          onRightClick={(e) => {
            this.props.onRightClick && this.props.onRightClick(e);
          }}
          onLongPress={(e) =>
            !isDragging && this.props.onLongPress && this.props.onLongPress(e)
          }
          style={[
            styleSheet.bullet,
            {
              width: styleSheet.bullet.width * sizeFactor,
              height: styleSheet.bullet.height * sizeFactor,
              // width: 20,
              // height: 20,
              // justifyContent: "center",
              // alignItems: "center",
              // paddingTop: 4,
              borderWidth: 0,
            },
          ]}
        >
          <View
            style={{
              backgroundColor: color,
              width: 6,
              height: 6,
              borderRadius: 6,
            }}
          />
        </TouchableOpacity>
      );

    return (
      <View
        // pointerEvents={status == "placeholder" ? "none" : undefined}
        style={[
          isDragging || isHovered
            ? {
                zIndex: 999,
                position: "relative",
              }
            : {},
          { opacity },
        ]}
      >
        {isDragging && this.renderPlaceholder(value)}
        <Draggable
          onDragStart={() => {
            this.setState({ isDragging: true });
            this.listenForMetaKey();
            this.props.onDragStart && this.props.onDragStart();
          }}
          onDragEnd={() => {
            !!this.touchableRef?.cancelPress && this.touchableRef.cancelPress();
            !!this.unsubscribeRedux && this.unsubscribeRedux();
            this.props.onDragEnd && this.props.onDragEnd();
            setTimeout(() => {
              this.setState({ isDragging: false, metaKey: false });
            }, 0);
          }}
          item={moment}
          global
          disabled={!ENV.WEB}
        >
          {(isDragging) => {
            return (
              <Hoverable
                delay={this.props.hoverDelay}
                onHoverIn={() => {
                  this.setState({ isHovered: true });
                  // this.props.onHoverIn && this.props.onHoverIn();

                  if (ENABLED_SCROLL_TO_SET_QUOTA)
                    setTimeout(() => {
                      if (this.state.isHovered) {
                        this.setState({ allowUpdatingQuota: true });
                        this.context.setHoveredMoment(
                          moment,
                          this.handleHoveredScroll,
                        );
                      }
                    }, 1200);

                  // store.dispatch({ type: "hovering/set_moment_id", momentId: moment.id });
                }}
                onHoverOut={async () => {
                  this.setState({
                    isHovered: false,
                    allowUpdatingQuota: false,
                    updatingQuota: false,
                  });
                  this.props.onHoverOut && this.props.onHoverOut();
                  this.context.setHoveredMoment(null);
                  this.handleUpdateQuota();
                  // store.dispatch({ type: "hovering/set_moment_id", momentId: null });
                }}
              >
                {(isHovered) => {
                  // if (status == "placeholder") isHovered = false;
                  let bulletStyle = styleSheet.bullet;
                  bulletStyle = { ...bulletStyle, ...styleSheet.largeBullet };
                  if (!ENV.WEB && mobileLarge) {
                    bulletStyle = {
                      ...bulletStyle,
                      ...styleSheet.mobileLargeBullet,
                    };
                  }
                  if (small)
                    bulletStyle = { ...bulletStyle, ...styleSheet.smallBullet };
                  if (giant)
                    bulletStyle = { ...bulletStyle, ...styleSheet.giantBullet };

                  //percent = 0.5;
                  //status = "value";
                  //value?.percent = 0.5;

                  return (
                    <View>
                      <TouchableOpacity
                        ref={this.touchableRef}
                        onPress={(e) => {
                          console.log("QUOTA", quotaWithinRange, percent);
                          if (isDragging) return null;
                          else if (!!this.props.onPress) {
                            this.props.onPress(e);
                            haptics.success();
                          }
                        }}
                        onDoublePress={this.props.onDoublePress}
                        onLongPress={(e) =>
                          (false && ENV.WEB) || isDragging
                            ? null
                            : this.props.onLongPress &&
                              this.handleLongPress(e, isDragging)
                        }
                        onRightClick={this.props.onRightClick}
                      >
                        <View
                          style={[
                            // styleSheet.bullet,
                            // // { cursor: "grab" },
                            // styleSheet.largeBullet,
                            // !ENV.WEB &&
                            //   mobileLarge &&
                            //   styleSheet.mobileLargeBullet,
                            // small && styleSheet.smallBullet,
                            // giant && styleSheet.giantBullet,
                            bulletStyle,
                            {
                              width: bulletStyle.width * sizeFactor,
                              height: bulletStyle.height * sizeFactor,
                              // backgroundColor,
                              // borderColor,
                            },
                            { borderWidth: 0 },
                            scale && {
                              transform: [{ scale }],
                            },
                            (isDragging || isHovered) &&
                            status != "placeholder" &&
                            !ignoreHover
                              ? {
                                  // backgroundColor: this.context.colors.empty,
                                  // transform: [{ scale: 1.5 }],
                                  transform: [{ scale: 2 }],
                                }
                              : {},
                            this.props.style,
                          ]}
                        >
                          <View
                            style={[
                              {
                                backgroundColor:
                                  this.props.backgroundColor || backgroundColor,
                              },
                              {
                                borderWidth: !!this.props.ringColor
                                  ? 1
                                  : borderWidth,
                                borderColor:
                                  this.props.ringColor || borderColor,
                                borderRadius,
                                ...borderStyle,
                              },
                              {
                                position: "absolute",
                                top: (4 - borderWidth) * 1,
                                right: (4 - borderWidth) * 1,
                                bottom: (4 - borderWidth) * 1,
                                left: (4 - borderWidth) * 1,
                                zIndex: -1,
                              },
                            ]}
                          />

                          <View
                            style={[
                              {
                                // ...StyleSheet.absoluteFillObject,
                                position: "absolute",
                                top: (4 - borderWidth) * 1,
                                right: (4 - borderWidth) * 1,
                                bottom: (4 - borderWidth) * 1,
                                left: (4 - borderWidth) * 1,
                                borderRadius: 999,
                                overflow: "hidden",
                                // borderWidth: 1,
                                // borderColor: "red",
                                justifyContent: "center",
                                alignItems: "center",
                              },
                            ]}
                          >
                            {this.props.noIcon ? (
                              this.renderBulletLetter(
                                value,
                                expanded,
                                iconColor,
                              )
                            ) : status == "note_X" && this.props.noteIcon ? (
                              <FontAwesome
                                name={
                                  !!moment?.completed_at
                                    ? "file-text"
                                    : "file-text-o"
                                }
                                name="file-text-o"
                                color={this.props.iconColor || iconColor}
                                size={iconSize}
                              />
                            ) : status == "note_X" &&
                              (!!moment?.completed_at ||
                                !!moment?.value?.completed_at) ? (
                              <FontAwesome
                                name="sticky-note"
                                color={iconColor}
                                size={14}
                              />
                            ) : status == "note_x" &&
                              !value?.icon &&
                              !value?.inherited_icon ? (
                              <FontAwesome5
                                name="sticky-note"
                                color={this.props.iconColor || iconColor}
                                size={14}
                              />
                            ) : ["progress", "placeholder"].includes(status) ? (
                              <Entypo
                                name={"check"}
                                color={iconColor}
                                size={iconSize}
                              />
                            ) : pinIcon ? (
                              <MaterialIcons
                                name={"push-pin"}
                                color={this.props.iconColor}
                                size={iconSize}
                              />
                            ) : checkIcon ? (
                              <Entypo
                                name={"check"}
                                color={this.props.iconColor}
                                size={iconSize}
                              />
                            ) : ["composer"].includes(status) ? (
                              <MaterialIcons
                                name={"close"}
                                color={iconColor}
                                size={iconSize}
                              />
                            ) : (value?.icon || value?.inherited_icon) &&
                              (true || !value?.is_note) &&
                              !allowUpdatingQuota ? (
                              <Icon
                                color={this.props.iconColor || iconColor}
                                // doubleShot={popEffect}
                                // color={colorHelpers.hexToRgbaString(
                                //   this.context.colors.darkForeground,
                                //   0.5
                                // )}
                                size={iconSize}
                                name={iconName}
                              />
                            ) : (
                              this.renderBulletLetter(
                                value,
                                expanded,
                                iconColor,
                              )
                            )}
                          </View>

                          {popEffect &&
                            this.renderShading(
                              color,
                              darkColor,
                              ringSize,
                              borderWidth,
                            )}

                          {updatingQuota && !disableQuotaEdit ? (
                            <MomentRing
                              percent={1}
                              color={this.context.colors.foreground}
                              size={ringSize}
                              // strokeFactor={2}
                              // gapless
                              notches={new Array(
                                quota + this.state.scrollDiff,
                              ).fill(1)}
                            />
                          ) : (
                            (!!percent ||
                              (!!parseFloat(value?.percent) &&
                                (!value?.child_ids?.length ||
                                  !this.context.pensieve ||
                                  true))) &&
                            !["note", "progress"].includes(status) &&
                            (loading ? (
                              <ActivityIndicator
                                color={ringColor}
                                size={"small"}
                              />
                            ) : (
                              <MomentRing
                                percent={
                                  !!percent || percent === 0
                                    ? percent
                                    : value?.percent
                                }
                                color={this.props.ringColor || ringColor}
                                size={ringSize}
                                pulse={valueHelpers.getRipe(value)}
                                strokeFactor={strokeFactor}
                                gapless
                              />
                            ))
                          )}
                        </View>
                      </TouchableOpacity>

                      {showTooltip &&
                        isHovered &&
                        !isDragging &&
                        //!!value?.text?.length &&
                        this.renderTooltip(
                          value,
                          eventsWithinRange,
                          quotaWithinRange,
                        )}

                      {showActionsOnHover &&
                        bulletIsHovered &&
                        !isDragging &&
                        this.renderActionButton(color)}
                    </View>
                  );
                }}
              </Hoverable>
            );
          }}
        </Draggable>
      </View>
    );
  }

  renderShading = (color, darkColor, ringSize, borderWidth) => {
    return null;
    let lightColor = colorHelpers.modifyHex(color, 1.2);
    let highlight = colorHelpers.hexToRgbaString(lightColor, 0.9);

    let darkerColor = colorHelpers.modifyHex(darkColor, 0.6);
    // let darkestColor = colorHelpers.modifyHex(darkColor, 0.5);
    let shadow = colorHelpers.hexToRgbaString(darkerColor, 0.1);
    let lowlight = colorHelpers.hexToRgbaString(darkerColor, 0.7);
    // let lowlight = darkestColor;
    // let shadow = darkColor;
    // shadow = "transparent";
    // highlight = "transparent";
    // lowlight = "transparent";

    let shadowWidth = ringSize / 20;

    // return (
    //   <View
    //     style={{
    //       position: "absolute",
    //       top: (4 - borderWidth) * 1,
    //       right: (4 - borderWidth) * 1,
    //       bottom: (4 - borderWidth) * 1,
    //       left: (4 - borderWidth) * 1,
    //       // overflow: "hidden",
    //       zIndex: -3,
    //     }}
    //   >
    //     <View
    //       // shadow
    //       style={{
    //         ...StyleSheet.absoluteFillObject,
    //         borderRadius: 999,
    //         backgroundColor: shadow,
    //         backgroundColor: darkerColor,
    //         // transform: [{ translate: { x: 1, y: 1 } }],
    //         transform: [{ translateY: 1 }],
    //       }}
    //     />
    //   </View>
    // );

    return (
      <View
        style={{
          position: "absolute",
          top: (4 - borderWidth) * 1,
          right: (4 - borderWidth) * 1,
          bottom: (4 - borderWidth) * 1,
          left: (4 - borderWidth) * 1,
          overflow: "hidden",
          // zIndex: -1,
        }}
      >
        <View
          // shadow
          style={{
            ...StyleSheet.absoluteFillObject,
            borderRadius: 999,
            borderColor: shadow,
            borderWidth: shadowWidth,
            // zIndex: -2,
          }}
        />
        {/*<View
          // lowlight
          style={{
            ...StyleSheet.absoluteFillObject,
            // top: 1,
            // left: 1,
            // right: 1,
            // bottom: 1,
            borderRadius: 999,
            borderColor: lowlight,
            borderBottomWidth: shadowWidth * 1.5,
            // borderRightWidth: 1,
            // zIndex: -2,
          }}
        />*/}
        {/*<View
          // highlight
          style={{
            ...StyleSheet.absoluteFillObject,
            top: 1,
            left: 1,
            right: 1,
            bottom: 1,
            borderRadius: 999,
            // transform: [{ translate: { x: 1, y: 1.5 } }],
            borderColor: highlight,
            borderTopWidth: shadowWidth / 2,
            borderLeftWidth: shadowWidth / 2,
            zIndex: 1,
          }}
        />*/}
      </View>
    );
  };

  renderActionButton = (color) => {
    return (
      <Hoverable
        // delay
        onHoverIn={() =>
          this.props.onHoverInOptions && this.props.onHoverInOptions()
        }
        // onHoverOut={() => this.props.onHoverOut && this.props.onHoverOut()}
        onHoverOut={() =>
          this.props.onHoverOutOptions && this.props.onHoverOutOptions()
        }
      >
        {(isHovered) => (
          <View
            style={{
              position: "absolute",
              right: "110%",
              top: -2,
              backgroundColor: isHovered ? color : "transparent",
              backgroundColor: isHovered
                ? this.context.colors.fill
                : "transparent",
              borderRadius: this.context.sizes.smallBorderRadius,
              borderRadius: 99,
              padding: this.context.sizes.small,
            }}
          >
            <TouchableOpacity onPress={this.props.onShowActions}>
              {/*<AntDesign
                // name="menufold"
                name="menuunfold"
                color={isHovered ? this.context.colors.lightForeground : color}
                size={this.context.sizes.smallItemHeight}
              />*/}
              <Feather
                name="more-horizontal"
                color={isHovered ? this.context.colors.lightForeground : color}
                color={color}
                size={17}
              />
            </TouchableOpacity>
          </View>
        )}
      </Hoverable>
    );
  };

  renderBulletLetter = (value, expanded, iconColor) => {
    let { updatingQuota, quota, disableQuotaEdit } = this.state;
    let { moment } = this.props;
    // if (value?.is_note) {
    //   return <FontAwesome5 name="sticky-note" color={iconColor} size={14} />;
    //   return <MaterialIcons name="notes" color={iconColor} size={12} />;
    // }
    // let hasChildren = !!value?.child_ids?.length;

    if (false)
      return (
        <View
          style={[
            this.styles().bullet,
            !value?.is_note && this.styles().taskBullet,
          ]}
        />
      );

    let hasChildren = false;
    let bulletLetter = !hasChildren
      ? this.bulletLetter(value)
      : expanded
        ? "v"
        : ">";
    let style = null;
    if (bulletLetter == "•") {
      style = {
        fontSize: this.context.sizes.giant,
        lineHeight: this.context.sizes.giant,
      };
      return (
        <View
          style={{
            borderRadius: 99,
            backgroundColor: this.context.colors.foreground,
            width: 6,
            height: 6,
          }}
        />
      );
    }
    if (updatingQuota) {
      style = { fontSize: this.context.sizes.default };
      if (disableQuotaEdit) {
        bulletLetter = "x";
      } else {
        bulletLetter = quota + this.state.scrollDiff;
      }
    }
    return (
      <Text
        style={[
          styleSheet.bullet,
          {
            color: iconColor,
            borderWidth: 0,
            fontSize: this.context.sizes.default * 1.4,
          },
          ENV.WEB && {
            height: this.context.sizes.default * 1,
            lineHeight: this.context.sizes.default * 0.7,
          },
          style,
        ]}
      >
        {bulletLetter}
      </Text>
    );
  };

  bulletLetter = (value) => {
    let bullet = "•";
    return bullet;
    let str = value?.text;
    if (!!str?.length && !value?.is_note) {
      let caps = str.replace(/[^A-Z]+/g, "");
      if (!!caps?.length) {
        bullet = caps[0];
      } else {
        bullet = str[0];
      }
    }
    return bullet;
  };

  renderTooltip = (
    value,
    eventsWithinRange = null,
    quotaWithinRange = null,
  ) => {
    let { tooltipText, tooltipOptions = {}, chapter } = this.props;
    let quotaText = null;
    if ((!!chapter, eventsWithinRange != null && quotaWithinRange != null)) {
      quotaText = `[${eventsWithinRange}/${quotaWithinRange}] this ${chapterHelpers.getChapterChunk(
        chapter,
      )}`;
    }
    return (
      <Tooltip {...tooltipOptions}>
        {tooltipText ||
          richTextHelpers.filterRichText(
            value?.title || value?.text,
            value,
          )}{" "}
        {quotaText || ""}
      </Tooltip>
    );
  };

  renderPlaceholder = (value) => {
    let { metaKey } = this.state;
    return (
      <View
        style={[styleSheet.bullet, { position: "absolute", borderWidth: 1 }]}
      >
        {metaKey ? (
          <FontAwesome name="share" color={this.context.colors.foreground} />
        ) : (
          <MaterialIcons
            name="control-point-duplicate"
            color={this.context.colors.foreground}
          />
        )}
      </View>
    );
  };

  listenForMetaKey = () => {
    let { dragging } = store.getState();
    this.setState({ metaKey: dragging.metaKey });
    this.unsubscribeRedux = store.subscribe(() => {
      let { dragging } = store.getState();
      console.log(dragging.metaKey);
      this.setState({ metaKey: dragging.metaKey });
    });
  };

  handleLongPress = (e, isDragging) => {
    console.log("long press,", isDragging);
    this.props.onLongPress(e);
  };

  handleHoveredScroll = (delta) => {
    let { updatingQuota, quota, disableQuotaEdit } = this.state;
    if (this.quotaScrollCoolingDown) return;
    if (!updatingQuota) {
      this.setState({ updatingQuota: true });
      this.quotaScrollCoolingDown = true;
      this.asdfasdf = setTimeout(() => {
        this.quotaScrollCoolingDown = false;
      }, 300);
    } else if (delta != 0) {
      if (disableQuotaEdit) return;
      // this.scrollDiff = Math.round(Math.max(0, this.scrollDiff + delta / 40));
      // this.setState({ scrollDiff: this.scrollDiff });
      let diff = Math.round(Math.min(Math.abs(delta) / 20, 1));
      console.log("delta!!", delta, diff);
      if (delta > 0) {
        // quota = quota + diff;
        quota = quota + 1;
      } else {
        // quota = Math.max(0, quota - diff);
        quota = Math.max(0, quota - 1);
      }
      this.setState({ quota, quotaHasChanged: true });

      this.quotaScrollCoolingDown = true;
      this.asdfasdf = setTimeout(() => {
        this.quotaScrollCoolingDown = false;
      }, 300);
    }
  };

  handleUpdateQuota = async () => {
    let { moment } = this.props;
    let { quota, disableQuotaEdit, quotaHasChanged } = this.state;
    if (disableQuotaEdit || !quotaHasChanged) return;

    if (!quota) quota = null;
    let res = await momentActions.update(moment.id, { quota });
    console.log(res);
    this.setState({ quotaHasChanged: false });
  };

  styles = () => ({
    bullet: {
      width: 7,
      height: 7,
      borderRadius: 7,
      backgroundColor: colorHelpers.hexToRgbaString(
        this.context.colors.foreground,
        0.5,
      ),
    },
    taskBullet: {
      width: 9,
      height: 9,
      borderRadius: 9,
      borderColor: colorHelpers.hexToRgbaString(
        this.context.colors.foreground,
        0.5,
      ),
      borderWidth: 2,
      backgroundColor: "transparent",
    },
  });
}
